import React from "react";
import { TwoRow } from "../../core/layouts";
import { Text, Input } from "react_reusable_components";
import { customInputStyle } from "../../components/CustomInput/CustomInput";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { addUserFormFieldNames } from "../../validationSchema/addUserManagementSchema";
import { useIntl } from "react-intl";
import variables from "../../themes/base/styles/variables";

const { TextArea } = Input;

const DNSDAddressStyle = {
  dnsdLabelStyle: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
    marginTop: variables.marginMedium,
  },
  dnsdInputStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    color: variables.textDefault,
    border: `1px solid ${variables.grey4}`,
    resize: "none",
    padding: `${variables.paddingSmall2} ${variables.paddingSmall} ${variables.paddingXXXXLarge} ${variables.paddingSmall}`,
  },
  bottomSectionStyle: {
    marginTop: variables.marginSmallest,
  },
  fullWidth: {
    width: variables.fullWidth,
  },
};

export default function DNSDAddressContainer({
  values,
  errors,
  touched,
  handleChange,
}) {
  const intl = useIntl();

  return (
    <TwoRow
      topSection={
        <Text style={DNSDAddressStyle.dnsdLabelStyle}>
          {getLocalizedMessage(intl, "address.dnsd.text")}
          <Text style={customInputStyle.requiredStyle}>&nbsp;*</Text>
        </Text>
      }
      bottomSection={
        <div style={DNSDAddressStyle.fullWidth}>
          <TextArea
            placeholder={getLocalizedMessage(
              intl,
              "address.dnsd.text.placeholder"
            )}
            style={DNSDAddressStyle.dnsdInputStyle}
            value={values[addUserFormFieldNames.ADDRESS]}
            error={errors[addUserFormFieldNames.ADDRESS]}
            name={addUserFormFieldNames.ADDRESS}
            onChange={handleChange}
          />
          {!!errors[addUserFormFieldNames.ADDRESS] &&
            touched[addUserFormFieldNames.ADDRESS] && (
              <Text
                style={{
                  ...customInputStyle.errorStyle,
                  position: "unset",
                }}
                type="danger"
              >
                {errors[addUserFormFieldNames.ADDRESS]}
              </Text>
            )}
        </div>
      }
      bottomSectionStyle={DNSDAddressStyle.bottomSectionStyle}
    />
  );
}
